import { createAsyncThunk } from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";

export interface CompletedTask {
  id?: number;
  completedTaskName: string;
  state: string;
  status: boolean;
  createBy?: string;
  updatedBy?: string;
  createDate?: string;
  updateDate?: string;
}
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchcompletedTasks = createAsyncThunk(
  "completedTask/fetchcompletedTasks",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                // Handle cases like { from_date: ..., to_date: ... }
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                });
              } else {
                // Handle primitive values (string, number)
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      const response: any = await Axios.get(
        `/completedTask/?${params.toString()}`
      );
      // const response: any = await Axios.get(`/district/`, {
      //   params: {
      //     page,
      //     page_size: pageSize,
      //     search: search || undefined,
      //     filters: filters ? JSON.stringify(filters) : undefined,
      //   },
      // });

      // response.data;
      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchcompletedTasks error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch districts");
    }
  }
);

export const fetchOnlyAllcompletedTasks = createAsyncThunk(
  "",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get("/completedTask");
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch completedTask by ID"
      );
    }
  }
);

export const fetchcompletedTaskById = createAsyncThunk(
  "completedTask/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/completedTask/${id}/get/`);
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch completedTask by ID"
      );
    }
  }
);

export const fetchcompletedTaskByDropDown = createAsyncThunk(
  "completedTask/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/completedTask/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch completedTask list"
      );
    }
  }
);

export const updatecompletedTask = createAsyncThunk(
  "completedTask/updatecompletedTask",
  async ({ id, completedTaskData }: { id: string; completedTaskData: any }) => {
    const response: any = await Axios.put(
      `/completedTask/${id}/update/`,
      completedTaskData
    );
    return response;
  }
);

export const addcompletedTask = createAsyncThunk(
  "completedTask/addcompletedTask",
  async (completedTaskData: any) => {
    const response = await Axios.post(
      `/completedTask/create/`,
      completedTaskData
    );
    return response.data;
  }
);

export const exportcompletedTaskCSV = async () => {
  const response = await Axios.get("/completedTask/?export=csv", {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "completedTask.csv",
  };
};
